import { render, staticRenderFns } from "./Pdf.vue?vue&type=template&id=241ffffb&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"
import style0 from "./Pdf.vue?vue&type=style&index=0&id=241ffffb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ffffb",
  null
  
)

export default component.exports